import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../../context/LocaleContext'

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  padding-top: 40px;
  color: #282d41;
`

const MessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60%;
  border-top: 3px solid #282d41;
  border-bottom: 3px solid #282d41;
  height: 100px;
  box-sizing: border-box;

  @media (max-width: 420px) {
    width: 90%;
  }
`

const TipsContainer = styled.div`
  width: 60%;
  box-sizing: border-box;
  padding: 20px 0 0 40px;
  color: #a4a9b7;

  @media (max-width: 420px) {
    width: 100%;
    padding-top: 20px;
  }
`

const StyledList = styled.ul`
  font-size: 14px;
`

const StyledTitle = styled.div`
  padding-bottom: 20px;
`

const StyledListItem = styled.li`
  margin-left: 20px;
`

const NoResult = ({searchTerm}) => {
  const localeState = useLocaleState()
  const messagePrefix = _L({
    key: 'Sorry we could not find any results matching',
    localeState
  })
  const message = `${messagePrefix} "${searchTerm}`

  return (
    <Container>
      <MessageContainer>
        <div>{message}</div>
      </MessageContainer>
      <TipsContainer>
        <StyledTitle>Search Tips</StyledTitle>
        <StyledList>
          <StyledListItem>Check your spelling and try again</StyledListItem>
          <StyledListItem>
            Try a similar but different search term
          </StyledListItem>
          <StyledListItem>Keep your search term simple</StyledListItem>
        </StyledList>
      </TipsContainer>
    </Container>
  )
}

export default NoResult
